
import React from 'react'

export default ({onClick}) => {
  return (<div className="box clk">
            <i className="fas fa-check show-hide"></i>
         </div>
 )
}



